module.exports = "<p>Latest update currency info:</p>\n<p>{{currency[0].date * 1000 | date:'medium'}}</p>\n"